import { render, staticRenderFns } from "./UserCreated.vue?vue&type=template&id=903798b6&scoped=true&"
var script = {}
import style0 from "./UserCreated.vue?vue&type=style&index=0&id=903798b6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "903798b6",
  null
  
)

export default component.exports